import { useState } from "react";
import { api } from "@/lib/api";
import { CloudDownload, Loader2, X } from "lucide-react";

export default function CacheLogosButton({ onDone }) {
    const [busy, setBusy] = useState(false);
    const [report, setReport] = useState(null);

    const run = async () => {
        setBusy(true);
        try {
            const { data } = await api.post("/admin/media/cache-external-logos");
            setReport(data);
            onDone?.();
        } catch (e) {
            setReport({ error: e.response?.data?.detail || "Failed" });
        } finally {
            setBusy(false);
        }
    };

    return (
        <>
            <button onClick={run} disabled={busy} className="btn-outline" data-testid="cache-logos-button"
                title="Shkarko logot nga faqet e jashtme dhe ruaji në storage">
                {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <CloudDownload className="w-4 h-4" />}
                Ruaj logot në storage
            </button>
            {report && (
                <div className="basis-full border border-slate-200 bg-slate-50 p-3 text-xs font-mono relative" data-testid="cache-logos-report">
                    <button onClick={() => setReport(null)} className="absolute top-2 right-2" data-testid="cache-logos-report-close">
                        <X className="w-3.5 h-3.5" />
                    </button>
                    {report.error ? (
                        <div className="text-red-600">{report.error}</div>
                    ) : (
                        <>
                            <div data-testid="cache-logos-summary">
                                U ruajtën: <b className="text-green-700">{report.cached.length}</b> · Dështuan:{" "}
                                <b className="text-red-600">{report.failed.length}</b> · Tashmë në storage: {report.skipped}
                            </div>
                            {report.cached.map((c, i) => <div key={`c${i}`} className="text-green-700">✓ {c.name}</div>)}
                            {report.failed.map((f, i) => (
                                <div key={`f${i}`} className="text-red-600 break-all">✗ {f.name} — {f.error} ({f.url})</div>
                            ))}
                        </>
                    )}
                </div>
            )}
        </>
    );
}
